"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRateCalculatorLocationOptionsDto = instanceOfRateCalculatorLocationOptionsDto;
exports.RateCalculatorLocationOptionsDtoFromJSON = RateCalculatorLocationOptionsDtoFromJSON;
exports.RateCalculatorLocationOptionsDtoFromJSONTyped = RateCalculatorLocationOptionsDtoFromJSONTyped;
exports.RateCalculatorLocationOptionsDtoToJSON = RateCalculatorLocationOptionsDtoToJSON;
exports.RateCalculatorLocationOptionsDtoToJSONTyped = RateCalculatorLocationOptionsDtoToJSONTyped;
/**
 * Check if a given object implements the RateCalculatorLocationOptionsDto interface.
 */
function instanceOfRateCalculatorLocationOptionsDto(value) {
    if (!('state' in value) || value['state'] === undefined)
        return false;
    if (!('areaName' in value) || value['areaName'] === undefined)
        return false;
    return true;
}
function RateCalculatorLocationOptionsDtoFromJSON(json) {
    return RateCalculatorLocationOptionsDtoFromJSONTyped(json, false);
}
function RateCalculatorLocationOptionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'state': json['state'],
        'areaName': json['areaName'],
    };
}
function RateCalculatorLocationOptionsDtoToJSON(json) {
    return RateCalculatorLocationOptionsDtoToJSONTyped(json, false);
}
function RateCalculatorLocationOptionsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'state': value['state'],
        'areaName': value['areaName'],
    };
}
//# sourceMappingURL=RateCalculatorLocationOptionsDto.js.map